import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'

import { sanitizeFilename } from '../../utils/sanitizeFilename'

type DownloadParams = {
  masterUuid: string
  masterName: string
}

type Options = Omit<
  UseMutationOptions<void, Error, DownloadParams>,
  'mutationFn'
>

export const useMutationDownloadMasterCsv = (options?: Options) => {
  return useMutation({
    ...options,
    mutationFn: async ({ masterUuid, masterName }: DownloadParams) => {
      const response = await baseClient
        .getApi(MasterApi)
        .getMasterCsvRaw({ masterUuid })
        .catch(handleHTTPError)

      const bytes = await response.raw.bytes()
      const blob = new Blob([bytes], { type: 'text/csv;charset=utf-8' })

      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      try {
        link.href = url
        link.download = `${sanitizeFilename(masterName)}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } finally {
        URL.revokeObjectURL(url)
      }
    },
  })
}
